/** Sources under Paste a link. Append an entry when a new site is added. */
const SOURCE_LOGOS = [
  { id: "sketchfab", name: "Sketchfab", src: "/logos/sketchfab.png" },
  { id: "fab", name: "Fab", src: "/logos/fab.png" },
  { id: "cgtrader", name: "CGTrader", src: "/logos/cgtrader.svg" },
  {
    id: "artstation",
    name: "ArtStation",
    src: "/logos/artstation.svg",
    word: "ArtStation",
  },
  { id: "tripo", name: "Tripo", src: "/logos/tripo.png" },
];

const Logo = ({ logo }) => {
  if (!logo.word) {
    return (
      <img
        className={`source-logo source-logo-${logo.id}`}
        src={logo.src}
        alt=""
        draggable="false"
      />
    );
  }

  return (
    <span className={`source-logo source-logo-${logo.id} source-logo-lockup`}>
      <img src={logo.src} alt="" draggable="false" />
      <span className="source-logo-word">{logo.word}</span>
    </span>
  );
};

const SourceMarquee = () => (
  <div
    className="source-marquee"
    role="img"
    aria-label={SOURCE_LOGOS.map((logo) => logo.name).join(", ")}
  >
    {[0, 1].map((copy) => (
      <div className="source-marquee-track" key={copy}>
        {SOURCE_LOGOS.map((logo) => (
          <Logo key={`${logo.id}-${copy}`} logo={logo} />
        ))}
      </div>
    ))}
  </div>
);

export default SourceMarquee;
